export const name = 'rnTutorial';
export default function rnTutorial(rnHttp, rnLocale) {
  'ngInject';

  const SUPPORT_SERVICE = 'supportapp_service';

  let service = {
    getAll,
    getByTitle,
  };
  return service;

  /////////////////

  function getAll(queryParams = {}) {
    return rnLocale.getBestFit().then(locale => {
      if (!queryParams.hasOwnProperty('active')) {
        queryParams.active = true;
      }
      if (!queryParams.hasOwnProperty('locale')) {
        queryParams.locale = locale.value;
      }

      let config = {
        params: queryParams,
        cache: true,
        rhino: {
          allow401: true
        },
      };
      return rnHttp.get(SUPPORT_SERVICE, 'tutorials', config).then(resp => {
        return resp.data;
      });
    });
  }

  function getByTitle(title, type) {
    return getAll().then(tutorials => {
      return _.find(tutorials.list, tutorial => {
        if ( (type !== undefined) && (type !== tutorial.type) ) {
          return false;
        }

        let analyticsTitle = tutorial.analyticsTitle;
        if (analyticsTitle) {
          analyticsTitle = analyticsTitle.trim();
        }
        return analyticsTitle === title;
      });
    });
  }
}



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/tutorial/tutorial.service.js